import ReCAPTCHA from 'react-google-recaptcha-enterprise';
import env from '@frontend/env';
import { useRecaptcha } from './hooks';

const reCaptchaKey = env.PAY_CAPTCHAV2_SITE_KEY;

export const Recaptcha = () => {
  const { setCaptchaToken, recaptchaRef } = useRecaptcha();

  const handleCaptcha = (token: string | null) => {
    if (!!token) {
      setCaptchaToken(token);
    } else {
      setCaptchaToken(null);
    }
  };

  return <ReCAPTCHA ref={recaptchaRef} sitekey={reCaptchaKey} onChange={handleCaptcha} />;
};
